/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-dict-select.vue?vue&type=template&id=a181f966&scoped=true"
import script from "./j-dict-select.vue?vue&type=script&lang=js"
export * from "./j-dict-select.vue?vue&type=script&lang=js"
import style0 from "./j-dict-select.vue?vue&type=style&index=0&id=a181f966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a181f966",
  null
  
)

export default component.exports